<!--
 * @Author: WangYuzhou
 * @Date: 2023-01-04 23:37:06
 * @LastEditors: WangYuzhou
 * @LastEditTime: 2024-06-12 13:45:54
 * @Description: TODO
-->
<template>
  <div id="top-header">
    <dv-decoration-8 class="header-left-decoration" :reverse="true" />
    <dv-decoration-5 class="header-center-decoration" />
    <dv-decoration-8 class="header-right-decoration" />
    <div class="center-title" @click="test">天泽大宗商品数字化产业平台数据中心</div>
  </div>
</template>

<script>
export default {
  name: 'TopHeader',
  methods: {
    test () {
      this.$emit('onClick', '一些数据') // 触发自定义事件
    }
  }
}
</script>

<style lang="less">
#top-header {
  position: relative;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  margin: 20px 20px 0 20px;
  // background-color: red;

  .header-center-decoration {
    width: 40%;
    height: 60px;
    margin-top: 40px;
  }

  .header-left-decoration, .header-right-decoration {
    width: 25%;
    height: 60px;
  }

  .center-title {
    position: absolute;
    font-size: 30px;
    font-weight: bold;
    left: 50%;
    top: 15px;
    transform: translateX(-50%);
  }
}
</style>
